import { searchCategory } from 'odooApi/categoryProdut';
import { getSingleProduct, searchProduct } from 'odooApi/product';
import { prix_AxeMotoriseTradi } from 'constants/CalculSimulateurData.js/Axe_Motorise';
import formInputsTypes from 'constants/simulatorData/simulatorConstant';
const MIN_WIDTH = 0;

import {
    axeData,
    createAxe,
    isWithAgraffe,
    Moteur,
    typeMoteurRadioFilaire,
    typeMoteurRadioFilaireSolaire,
    typeMoteursomfy,
} from 'constants/simulatorDataDetails/simulatorConstant';
import { MesureLargeur } from '../rideauMetallique/data';





const typeMesureLargeur = {
    id: 'VR-TR-AXE-TMOW',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureLargeur',
    className: 'col-6',
    label: 'Mesure selon largeur',
    nextStepData: Moteur(),
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const largeur = currentFormValue?.values?.largeur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Largeur : ${largeur} mm FINI`

            },
            {
                id: 'RME',
                label: 'DC',
                value: 'DC',
                nextStep: false,
                description: `- Largeur : ${largeur} mm D.C`


            },

        ]
        fnSuccess(options);
    },
};

const largeur = {
    id: 'VR-TR-AXE-W',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'largeur',
    className: 'col-6',
    label: 'Largeur (mm)',
    defaultValue: MIN_WIDTH,
    nextStepData: typeMesureLargeur,
    nextStep: false,
    notIncludeDescription: true,
    validation: (value) => {
        return value > 0;
    },
};

const AxeMotorise = {
    id: 'VR-TR-AXE-API',
    type: formInputsTypes?.SELECT_INPUT,
    label: 'Sélectionner un axe',
    name: 'axe',
    nextStepData: largeur,
    nextStep: false,
    options: axeData
}

export default AxeMotorise;
